import React from 'react';
import PostScheduler from '../../components/social/PostScheduler';
import RSSFeed from '../../components/RSSFeed';

const SocialHub: React.FC = () => {
  return (
    <div className="p-6">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900">Social Media Hub</h1>
        <p className="mt-1 text-gray-600">
          Create, schedule, and manage your social media content
        </p>
      </div>

      {/* Post Creation and Management */}
      <div className="space-y-8">
        <PostScheduler />
        <RSSFeed />
      </div>
    </div>
  );
};

export default SocialHub;